import Text from 'components/Text/Text';
import React from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import style from './SendBtn.module.scss';

export const SendBtn: React.FC = () => {
	return (
		<Form.Item className={style.formItem}>
			<div className={style.container}>
				<Button theme="primaryBlue" type="submit">
					<Text translationNameSpace="form" translationKey="createSubcategoryLabel" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};
